
import type { ProjectData } from '../../types';
import Component from './Component';

const data: ProjectData = {
    slug: 'mindorio',
    title: 'Mindorio',
    description: 'Mindorio is a platform for mental health and wellness.',
    fileName: 'content.mdx',
    jsx: Component,
    info: {
        stack: ['React', 'TypeScript', 'Material-UI', 'Node.js', 'Next.js'],
        url: 'https://mindorio.unrealos.com',
    }
}

export default data;